// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import {
  APIResource,
  type RequestOptions,
  type WithResponse,
} from "../../core";
import type { ListPersonsResponseBody, Merchant, Person } from "../../types";
export type GetMerchantQueryParams = {
  version?: string;
};

export type ListPersonsQueryParams = {
  version?: string;
};

export type GetPersonQueryParams = {
  version?: string;
};

/**
 * API resource for the Merchants endpoints.
 *
 * Merchant account represents a single business entity at SumUp.
 */
export class Merchants extends APIResource {
  /**
   * Retrieve a merchant.
   */
  get(
    merchantCode: string,
    query?: GetMerchantQueryParams,
    options?: RequestOptions,
  ): Promise<Merchant> {
    return this._client.get<Merchant>({
      path: `/v1/merchants/${merchantCode}`,
      query,
      ...options,
    });
  }

  getWithResponse(
    merchantCode: string,
    query?: GetMerchantQueryParams,
    options?: RequestOptions,
  ): Promise<WithResponse<Merchant>> {
    return this._client.getWithResponse<Merchant>({
      path: `/v1/merchants/${merchantCode}`,
      query,
      ...options,
    });
  }

  /**
   * Returns a list of persons related to the merchant.
   */
  listPersons(
    merchantCode: string,
    query?: ListPersonsQueryParams,
    options?: RequestOptions,
  ): Promise<ListPersonsResponseBody> {
    return this._client.get<ListPersonsResponseBody>({
      path: `/v1/merchants/${merchantCode}/persons`,
      query,
      ...options,
    });
  }

  listPersonsWithResponse(
    merchantCode: string,
    query?: ListPersonsQueryParams,
    options?: RequestOptions,
  ): Promise<WithResponse<ListPersonsResponseBody>> {
    return this._client.getWithResponse<ListPersonsResponseBody>({
      path: `/v1/merchants/${merchantCode}/persons`,
      query,
      ...options,
    });
  }

  /**
   * Returns a single person related to the merchant.
   */
  getPerson(
    merchantCode: string,
    personId: string,
    query?: GetPersonQueryParams,
    options?: RequestOptions,
  ): Promise<Person> {
    return this._client.get<Person>({
      path: `/v1/merchants/${merchantCode}/persons/${personId}`,
      query,
      ...options,
    });
  }

  getPersonWithResponse(
    merchantCode: string,
    personId: string,
    query?: GetPersonQueryParams,
    options?: RequestOptions,
  ): Promise<WithResponse<Person>> {
    return this._client.getWithResponse<Person>({
      path: `/v1/merchants/${merchantCode}/persons/${personId}`,
      query,
      ...options,
    });
  }
}
